import { AxiosPromise } from 'axios';
import baseRequest from './baseRequest';

export interface Account {
  type: string;
  description: string;
  referenceId?: string;
}

export interface Product {
  title: string;
  description: string;
  accounts: Account[];
  hidden?: boolean;
  referenceId: string;
  detailsDisplay?: {
    body: string;
    title?: string;
    footers?: string[];
  };
}

export function getProducts(): AxiosPromise<Product[]> {
  return baseRequest.get('/api/account-opening/products');
}

export function updateAccountOpeningApp(
  topicId: string,
  params: { accounts: Account[]; productReferenceId?: string },
): AxiosPromise<any> {
  return baseRequest.patch(`/api/account-opening/applications/${topicId}/external`, params);
}
